// gtm.service.ts
import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class GtmService {
    private gtmId = 'GTM-MZQPZ9J';
    private loaded = false;

    constructor(@Inject(DOCUMENT) private document: Document) { }

    loadGtm() {
        if (this.loaded) return;

        // Step 1: Create the dataLayer and script
        const script = this.document.createElement('script');
        script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      (function(w,d,s,l,i){w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${this.gtmId}');
    `;
        this.document.head.appendChild(script);

        // Step 2: Add noscript iframe for no-JS support
        const noscript = this.document.createElement('noscript');
        noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
        this.document.body.appendChild(noscript);

        this.loaded = true;
    }
}
